module.exports = __webpack_public_path__ + "img/map-magnifier.5ec3db2.png";